module.exports = __webpack_public_path__ + "static/media/requests.c48889c7.svg";